import api from './api';

const taskService = {
  // Get all tasks with filters
  getAllTasks: async (params = {}) => {
    const response = await api.post('/tasks/tasks-filters', params);
    // API returns { tasks: [...], pagination: {...} }
    // Return as-is for TaskList component
    console.log(response)
    return {
      tasks: response.data.tasks || [],
      summary:response.data.summary,
      pagination: response.data.pagination || {}
    };
  },


  uploadTaskAttatchment: async (file, id) => {
    const formData = new FormData();

    file.forEach((attachment) => {
      formData.append("logo", attachment.file);
    });
    // formData.append('logo', file);
    formData.append('task_id', id);
    console.log("task id", id, file)
    const response = await api.post('/tasks/upload-task-Attachment', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  uploadTempAttatchment: async (file, id, folder_name) => {
    const formData = new FormData();
    formData.append('logo', file);
    formData.append('task_id', id);
    formData.append('folder_name', folder_name);
    console.log("task id", id, file)
    const response = await api.post('/temp-upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Get task by ID
  getTaskById: async (id) => {
    const response = await api.get(`/tasks/${id}`);
    return response.data;
  },

  // Create new task
  createTask: async (taskData) => {
    const response = await api.post('/tasks', taskData);
    return response.data;
  },

  // Update task
  updateTask: async (id, taskData) => {
    const response = await api.put(`/tasks/${id}`, taskData);
    return response.data;
  },

  // Delete task
  deleteTask: async (id) => {
    const response = await api.delete(`/tasks/${id}`);
    return response.data;
  },

  // Add comment to task
  addComment: async (id, comment) => {
    const response = await api.post(`/tasks/${id}/comments`, { comment });
    return response.data;
  },
  changeState: async (id, data) => {
    const response = await api.put(`/tasks/${id}/state`, data);
    return response.data;
  },

  submitBulkTasks: async (data) => {
    const response = await api.post(`/tasks/moveto-bulk-actions`, data);
    return response.data;
  },


  // Get task comments
  getComments: async (id) => {
    const response = await api.get(`/tasks/${id}/comments`);
    return response.data;
  },

  getAll: async (params = {}) => {
    try {
      const response = await api.get('/users', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  // Get tasks grouped by status for Kanban board
  getTasksByStatus: async (params = {}) => {
    const response = await api.get('/tasks/board/view', { params });
    return response.data;
  },

  // Update task status (for drag-and-drop)
  updateTaskStatus: async (id, status, order_index) => {
    const response = await api.patch(`/tasks/${id}/status`, { status, order_index });
    return response.data;
  },
  getParentTasksByProject: async (projectId) => {
    const response = await api.get(`/tasks/parent-tasks-by-project`, {
      params: { project_id: projectId },
    });
    return response.data;
  },

};

export default taskService;


